import React from 'react';

const Footer = () => {
  return (
    <footer className="footer d-flex justify-content-center pb-spacer">
      <a target="_blank" className="align-items-center" href="https://elrond.com/">
        <small>Powered by Elrond Network</small>
      </a>
    </footer>
  );
};

export default Footer;
